import { Layout } from '@/components/Layout'
import { getActiveSidebarKey } from '@/components/layouts/Sidebar/helpers'
import { Menu } from '@/components/Menu'
import { DashboardExperiments } from '@/experiments'
import { QuickNavigationHeapEvents } from '@/heap/heapEvents'
import { trackHeapEvent } from '@/heap/trackHeapEvent'
import { useIsMobile } from '@/hooks/useBreakpoint'
import { useFlag } from '@/hooks/useFlag'
import { type MenuProps } from 'antd'
import { useMemo } from 'react'
import { useLocation } from 'react-router'
import styles from './styles.module.scss'

export type MenuItemProps = NonNullable<Required<MenuProps>['items'][number]>
export interface SidebarProps extends MenuProps {
  menuItems: MenuItemProps[]
  width?: number | string
  collapsed: boolean
  setCollapsed: (value: boolean) => void
}

export function Sidebar({
  menuItems,
  width = 200,
  collapsed,
  setCollapsed,
  ...props
}: SidebarProps) {
  const { pathname } = useLocation()

  const isMobile = useIsMobile()

  const hasQuickNavigationFeature = useFlag(DashboardExperiments.quickNavigation)

  const selectedKeys: string[] = useMemo(() => getActiveSidebarKey(pathname), [pathname])

  return (
    <Layout.Sider
      className={styles.sidebarNavigationV2}
      theme="light"
      width={width}
      collapsible
      collapsedWidth={isMobile ? 0 : 50}
      collapsed={collapsed}
      breakpoint="lg"
      onCollapse={(value) => setCollapsed(value)}
    >
      <Menu
        {...props}
        theme="light"
        mode="inline"
        selectedKeys={selectedKeys}
        items={menuItems}
        onSelect={({ key }) => {
          if (hasQuickNavigationFeature) {
            trackHeapEvent(QuickNavigationHeapEvents.sidebarItemClicked, { path: key })
          }

          if (isMobile) {
            setCollapsed(true)
          }
        }}
      />
    </Layout.Sider>
  )
}
